// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__Fdy+a","swiper":"Partners_swiper__6Gd9K","slide":"Partners_slide__uLts5","image":"Partners_image__crLJH"};